import { FC } from 'react';

import { EngagementData as EngagementDataType } from 'modules/ai/XAI/audienceUserProfile';
import { useBrandAffinityTranslation } from 'modules/domains/brandAffinity';

import { getComparisonLabel, getComparisonText } from '../utils';
import {
  DefaultEventsText,
  EngagementCardContainer,
  LeftColumnData,
  MedianCompareText,
  RightColumnData,
  TotalEventsText,
} from './EngagementCard.styles';
import { CaptionSecondary, CaptionDisabled, UnspacedBody2Bold } from '../Styles';

export type EngagementDataProps = EngagementDataType;

export const EngagementData: FC<React.PropsWithChildren<EngagementDataProps>> = ({
  count,
  eventType,
  isDefault,
  labelCompare,
  median,
}) => {
  const { t } = useBrandAffinityTranslation();
  const affinityLabel = getComparisonLabel(t, labelCompare);
  const medianCompareText = getComparisonText(count, median);

  return (
    <EngagementCardContainer data-test="brand-affinity-xai-engagement-data">
      <LeftColumnData>
        <UnspacedBody2Bold>{eventType}</UnspacedBody2Bold>
        {isDefault ? (
          <CaptionDisabled>No data available</CaptionDisabled>
        ) : (
          <CaptionSecondary data-test="comparison-text">
            <MedianCompareText>{medianCompareText}</MedianCompareText>
            the median value for {affinityLabel} users
          </CaptionSecondary>
        )}
      </LeftColumnData>
      <RightColumnData>
        {isDefault ? (
          <DefaultEventsText>{count}</DefaultEventsText>
        ) : (
          <TotalEventsText>{count}</TotalEventsText>
        )}
      </RightColumnData>
    </EngagementCardContainer>
  );
};
